import styled from "@emotion/styled";

export const ThankYouHeader = styled.div(({ theme }) => ({
	h3: {
		...theme.project.typography.heading.h3,
		color: theme.project.colors.fontColors.main,
		margin: "24px auto"
	},
	h5: {
		...theme.project.typography.heading.h5,
		color: theme.project.colors.fontColors.main,
		margin: 0
	},
	display: "flex",
	flexDirection: "column",
	alignItems: "center"
}));

export const ConfirmationNumber = styled.div({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	marginBottom: "24px"
});
